import FormSandboxCtl from 'root/main/components/forms/formSandboxCtl';

const approvedCampaignIDs = ['111', '148', '149'];

declare global {
    interface Window {
        formSandboxContext?: {
            targetURL: string;
            event: Event;
        };
        VWO: {
            push: (args: [string, (data: string[]) => void]) => void;
        };
    }
}

const vwoOnVariationApplied = () => {
    const VWO = window.VWO || {};

    if (VWO && VWO.push) {
        VWO.push([
            'onVariationApplied',
            function (data: string[]) {
                const experimentID = data[1];
                const variationID = data[2];

                // Swap URLs on first segmentation click that matches experiment ID and variation ID
                if (
                    approvedCampaignIDs.includes(experimentID) &&
                    variationID === '2' &&
                    window.formSandboxContext
                ) {
                    const newURL = window.formSandboxContext?.targetURL.replace(
                        'wizard-lightbox',
                        'form-sandbox'
                    );
                    FormSandboxCtl().init(window.formSandboxContext?.event, newURL);
                }
            },
        ]);
    }
};

export default vwoOnVariationApplied;
